var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#fff",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.36,15.22a1.18,1.18,0,0,1-1.28.78c-.85,0-1.7,0-2.54,0a1,1,0,0,1-1.06-1.15,1,1,0,0,1,1-.84q1.46,0,2.91,0a1.07,1.07,0,0,1,1,.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.77,29.36A1.19,1.19,0,0,1,14,28.09c0-.85,0-1.7,0-2.55a1,1,0,0,1,1.15-1.06,1,1,0,0,1,.84,1c0,1,0,1.95,0,2.92a1.05,1.05,0,0,1-.77,1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23,15A7.23,7.23,0,1,1,15,7.78,7.25,7.25,0,0,1,22.23,15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,3.09V4.43a1,1,0,0,1-1,1.11,1,1,0,0,1-1-1.11V1.74a1,1,0,1,1,2,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1,14H4.41a1,1,0,1,1,0,2H1.74a1,1,0,1,1,0-2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53,8.61a1,1,0,0,1-1-.58.88.88,0,0,1,.16-1c.43-.45.87-.89,1.31-1.33.27-.27.53-.54.8-.79a1,1,0,1,1,1.37,1.36c-.67.7-1.35,1.39-2.06,2A2.23,2.23,0,0,1,22.53,8.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56,22.53a2.13,2.13,0,0,1-.3.53c-.68.71-1.37,1.4-2.07,2.08A1,1,0,0,1,4.8,23.8c.69-.72,1.4-1.43,2.12-2.12A.9.9,0,0,1,8,21.49,1,1,0,0,1,8.56,22.53Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62,7.59a1.13,1.13,0,0,1-.59.9.93.93,0,0,1-1-.07L6.9,8.31,4.82,6.23a.94.94,0,0,1-.19-1.11.91.91,0,0,1,.92-.54,1.14,1.14,0,0,1,.62.28c.72.68,1.42,1.38,2.1,2.09A3.28,3.28,0,0,1,8.62,7.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.44,24.34a1,1,0,0,1-.55,1,.84.84,0,0,1-1-.1c-.77-.74-1.53-1.49-2.26-2.26A1,1,0,0,1,23,21.62c.76.73,1.5,1.48,2.24,2.24A1.59,1.59,0,0,1,25.44,24.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/light-mode.4481a96d099f164be6369133088b1d01.svg";
export { ForwardRef as ReactComponent };